export var componentsLocales = {
  chooseFile: 'Select a file',
  choosedFile: 'File selected',
  orDragHere: 'or drag here',
  requestErrorText: 'The file could not be uploaded to the server, please try again later',
  errors: ['error', 'errors', 'errors'],
  warnings: ['warning', 'warnings', 'warnings']
};